export default __webpack_public_path__ + "static/media/expense_ic.3e347213.svg";